import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation, Pagination } from "swiper/modules";
import { Link } from "react-router-dom";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

import banner1 from "../assets/banners/banner1.png";
import banner2 from "../assets/banners/banner2.png";
import banner3 from "../assets/banners/banner3.png";
import "./HeroSlider.css";

function HeroSlider() {
  return (
    <div className="heroSlider">
      <Swiper
        modules={[Autoplay, Navigation, Pagination]}
        slidesPerView={1}
        autoplay={{ delay: 4000, disableOnInteraction: false }}
        navigation={true}
        pagination={{ clickable: true }}
        loop={true}
        onSlideChangeTransitionStart={() => {
          // Slide change hote hi purane text ko hide karo
          const contents = document.querySelectorAll(".heroContent");
          contents.forEach((el) => {
            el.style.opacity = "0";
            el.style.transform = "translateY(30px)";
          });
        }}
        onSlideChangeTransitionEnd={() => {
          // Active slide ke text ko smooth animate karo
          const activeContent = document.querySelector(".swiper-slide-active .heroContent");
          if (activeContent) {
            activeContent.style.opacity = "1";
            activeContent.style.transform = "translateY(0)";
            activeContent.style.transition = "all 0.7s ease-out";
          }
        }}
      >
        {/* Slide 1 */}
        <SwiperSlide>
          <div className="heroSlide" style={{ backgroundImage: `url(${banner1})` }}>
            <div className="heroContent">
              <h1>Premium Lace & Gota Collection</h1>
              <p>Elegant borders for sarees and designer garments</p>
              <Link to="/shop">
                <button className="heroBtn">Shop Now</button>
              </Link>
            </div>
          </div>
        </SwiperSlide>

        {/* Slide 2 */}
        <SwiperSlide>
          <div className="heroSlide" style={{ backgroundImage: `url(${banner2})` }}>
            <div className="heroContent">
              <h1>Elegant Zari Borders</h1>
              <p>Luxury embroidery trims for bridal fashion</p>
              <Link to="/shop">
                <button className="heroBtn">Explore More</button>
              </Link>
            </div>
          </div>
        </SwiperSlide>

        {/* Slide 3 */}
        <SwiperSlide>
          <div className="heroSlide" style={{ backgroundImage: `url(${banner3})` }}>
            <div className="heroContent">
              <h1>Wholesale Lace Deals</h1>
              <p>Bulk orders for boutiques & designers</p>
              <Link to="/contact">
                <button className="heroBtn">Contact Us</button>
              </Link>
            </div>
          </div>
        </SwiperSlide>
      </Swiper>
    </div>
  );
}

export default HeroSlider;